import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppDialog from "@crema/core/AppDialog";
import AppGridContainer from "@crema/core/AppGridContainer";
import { Fonts } from "shared/constants/AppEnums";
import { useDispatch } from "react-redux";
import { getPoliciesManuals } from "redux/actions/Policies";
import { useAuthUser } from "@crema/utility/AuthHooks";
import { RoutePermittedRole } from "shared/constants/AppConst";
import ManualList from "./ManualList";
import AddManual from "./AddManual";

export default function Manuals() {
    const dispatch = useDispatch();
    const { user } = useAuthUser();
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState({ add: false, edit: false });
    const [editRow, setEditRow] = useState("");
    const addHandler = () => {
        setAction({ add: true, edit: false });
        setOpen(true);
    };
    useEffect(() => {
        dispatch(getPoliciesManuals("MANUAL"));
    }, []);
    return (
        <AppGridContainer>
            <Grid item xs={12}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                    }}
                >
                    <Box
                        component="h2"
                        variant="h2"
                        sx={{
                            fontSize: 16,
                            color: "text.primary",
                            fontWeight: Fonts.SEMI_BOLD,
                        }}
                    >
                        Manuals
                    </Box>
                    {user.role === RoutePermittedRole.ADMIN || user.role === RoutePermittedRole.SUPER_ADMIN && (
                        <Box>
                            <Button variant="contained" onClick={addHandler}>
                                Add
                            </Button>
                        </Box>
                    )}
                </Box>
                <ManualList
                    setOpen={setOpen}
                    setAction={setAction}
                    setEditRow={setEditRow}
                />
                <AppDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    title={action.add === true ? "Add" : "Update"}
                >
                    <AddManual
                        action={action}
                        setOpen={setOpen}
                        editRow={editRow}
                    />
                </AppDialog>
            </Grid>
        </AppGridContainer>
    );
}
